import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getApiBase2Url } from '.';
import { TokenManager } from './token-manager';

export const apiClient2 = axios.create({
  baseURL: getApiBase2Url() + '/',
});

// Request interceptor to add JWT token
apiClient2.interceptors.request.use((config: AxiosRequestConfig) => {
  const authHeader = TokenManager.getAuthorizationHeader();
  if (authHeader) {
    config.headers = config.headers || {};
    config.headers.Authorization = authHeader;
  }
  return config;
});

// Response interceptor to handle token refresh and unauthorized errors
apiClient2.interceptors.response.use(
  (response: AxiosResponse<any>) => {
    return response;
  },
  async (error: any) => {
    const originalRequest = error.config;
    const isUnauthorized = error.response?.status === 401;

    if (isUnauthorized && !originalRequest._retry) {
      originalRequest._retry = true;

      // Try to refresh the token
      const refreshToken = TokenManager.getRefreshToken();
      if (refreshToken) {
        try {
          const response = await axios.post(`${getApiBase2Url()}/refresh`, {
            refreshToken: refreshToken,
          });

          const { accessToken, refreshToken: newRefreshToken } = response.data;
          TokenManager.setTokens(accessToken, newRefreshToken);

          // Retry the original request with the new token
          originalRequest.headers.Authorization = `Bearer ${accessToken}`;
          return apiClient2(originalRequest);
        } catch (refreshError) {
          // Refresh failed, redirect to login
          TokenManager.clearTokens();
          const sessionUrl = window.location.origin + '/session';
          window.location.href = sessionUrl;
          return Promise.reject(refreshError);
        }
      } else {
        // No refresh token, redirect to login
        TokenManager.clearTokens();
        const sessionUrl = window.location.origin + '/session';
        window.location.href = sessionUrl;
      }
    }
    return Promise.reject(error);
  },
);
